const extractFileSpecificCode = (response) => {
  const fileSnippets = [];
  const filePathRegex = /(?:\w+\s*):\s*([^\s]+\/[^\s]+\.\w+)/g; // Match patterns like "AnyLabel: path/to/file.ext"
  const codeBlockRegex = /```(?:\w+)?\n([\s\S]*?)```/g; // Match code blocks in triple backticks

  let fileMatch;
  let codeMatch;

  while (true) {
    fileMatch = filePathRegex.exec(response);
    codeMatch = codeBlockRegex.exec(response);

    if (!fileMatch || !codeMatch) break; // Ensure pairs are synchronized

    const filePath = fileMatch[1].trim();
    const codeSnippet = codeMatch[1].trim();

    fileSnippets.push({ filePath, codeSnippet });
  }

  return fileSnippets;
};

export default extractFileSpecificCode;
